import { createContext, useReducer } from 'react'
import { type NPCProviderProps, type NPCDataContextProps, type NPCDispatchContextProps, type NPC } from 'src/types'

import { reducer } from './reducer'
import { NPCs as npcsBackup } from 'src/data'

/* TEMP */
const NPCData: Record<string, NPC> = {}

npcsBackup.forEach((entry) => {
  NPCData[entry.id] = entry
})

export const NPCDataContext = createContext<NPCDataContextProps>({ NPCs: NPCData })
NPCDataContext.displayName = 'NPCDataContext'

export const NPCDispatchContext = createContext<NPCDispatchContextProps>({ dispatchNPCs: () => null })
NPCDispatchContext.displayName = 'NPCDispatchContext'

export const NPCProvider = ({ children }: NPCProviderProps) => {
  const [NPCs, dispatchNPCs] = useReducer(reducer, NPCData)
 
  return (
    <NPCDataContext.Provider value={{ NPCs}}>
      <NPCDispatchContext.Provider value={{ dispatchNPCs }}>
        {children}
      </NPCDispatchContext.Provider>
    </NPCDataContext.Provider>
    
  )
}
